import React from "react";
import styles from "./AboutBanner.module.scss";
import Shapes from "./assets/shapes.png";
import Icon from "./assets/icon.png";
import Computers from "./assets/computers.png";
const { aBanner, texts, shapes, content, footer, footerBlock, computers } =
  styles;
function AboutBanner() {
  return (
    <section className={`${aBanner} global-lr-pad`}>
      <div className={content}>
        <div className={texts}>
          <h3>About Us</h3>
          <h1>Wequick Pay</h1>
          <p>
            WeQuick Pay is the newest payment platform that allows users to send
            and receive money without any cards or bank details. All it takes is
            to scan a simple barcode with either a mobile device (Tablet or
            Smartphone) and a transaction becomes a done deal.
          </p>
          <p>
            This is your number one payment option as it relieves you of the
            stress of going about with your bank card and falling risk of being
            scammed at any time. It is easy to use, built for businesses, brands
            and individuals confident enough to make digital transactions.
          </p>
        </div>
        <div className={shapes}>
          <img src={Shapes} alt="Nicely laid out shapes" />
        </div>
      </div>
      <BannerFooter />
      <img
        src={Computers}
        className={computers}
        alt="Computers showing statistic of we quick pay"
      />
    </section>
  );
}

function BannerFooter() {
  return (
    <div className={footer}>
      <div className={footerBlock}>
        <div>
          <img src={Icon} alt="Vector logo" />
          <h2>Why use Wequick Pay?</h2>
          <p>
            Our payment platform saves users all that tedious process of filling
            in bank details or getting a card details verified, before making a
            transaction. Within just a few seconds you can get money right into
            your destination account with Wequick pay.
          </p>
        </div>
      </div>
      <div className={footerBlock}>
        <div>
          <img src={Icon} alt="Vector logo" />
          <h2>What more?</h2>
          <p>
            Anyone can use WeQuick Pay! The platform is easy to access and
            navigate. Payments have never been this simple!
          </p>
        </div>
      </div>
      <div className={footerBlock}>
        <div>
          <img src={Icon} alt="Vector logo" />
          <h2>Why use Wequick Pay?</h2>
          <p>
            Our payment platform saves users all that tedious process of filling
            in bank details or getting a card details verified, before making a
            transaction. Within just a few seconds you can get money right into
            your destination account with Wequick pay.
          </p>
        </div>
      </div>
    </div>
  );
}
export default AboutBanner;
